// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasksFieldDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  z-index: 1000;
}

.tasksFieldDropdownAlignRight {
  left: auto;
  right: 0;
}

.tasksFieldDropdownPortal {
  background: var(--ta-bg-primary);
  border: 1px solid var(--ta-border-primary);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  min-width: 240px;
  overflow: hidden;
  animation: dropdownAppear 0.15s ease-out;
}

.tasksFieldDropdownSearch {
  padding: 6px;
  border-bottom: 1px solid var(--ta-border-primary);
  font-size: 13px;
}

.tasksFieldDropdownSearchInput {
  width: 100%;
  padding: 6px 8px;
  background: var(--ta-bg-secondary);
  border: 1px solid var(--ta-border-primary);
  border-radius: 4px;
  color: var(--ta-text-primary);
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s ease;
}
.tasksFieldDropdownSearchInput::placeholder {
  color: var(--ta-text-tertiary);
}
.tasksFieldDropdownSearchInput:focus {
  border-color: var(--ta-blue-500);
}

.tasksFieldDropdownOptions {
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
}
.tasksFieldDropdownOptions::-webkit-scrollbar {
  width: 8px;
}
.tasksFieldDropdownOptions::-webkit-scrollbar-track {
  background: transparent;
}
.tasksFieldDropdownOptions::-webkit-scrollbar-thumb {
  background: var(--ta-border-dark);
  border-radius: 4px;
}
.tasksFieldDropdownOptions::-webkit-scrollbar-thumb:hover {
  background: #4a4a4a;
}

.tasksFieldDropdownOption {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--ta-text-primary);
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.1s ease;
  text-align: left;
}
.tasksFieldDropdownOption:hover, .tasksFieldDropdownOption.tasksFieldDropdownOptionFocused {
  background: var(--ta-bg-hover);
  color: var(--ta-text-primary);
}
.tasksFieldDropdownOption.tasksFieldDropdownOptionSelected {
  color: var(--ta-text-primary);
}

.tasksFieldDropdownOptionIcon {
  font-size: 14px;
  flex-shrink: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ta-text-tertiary);
}
.tasksFieldDropdownOptionIcon svg {
  flex-shrink: 0;
}

.tasksFieldDropdownOptionLabel {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tasksFieldDropdownOptionCheck {
  color: var(--ta-blue-500);
  flex-shrink: 0;
}

.tasksFieldDropdownOptionShortcut {
  font-size: 11px;
  color: var(--ta-text-secondary);
  background: var(--ta-bg-tertiary);
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid var(--ta-border-primary);
  flex-shrink: 0;
  font-family: monospace;
}

.tasksFieldDropdownEmpty {
  padding: 16px;
  text-align: center;
  color: var(--ta-text-dark-secondary);
  font-size: 13px;
}

.tasksFieldDropdownOptionCreate {
  color: var(--ta-blue-500);
}`, "",{"version":3,"sources":["webpack://./src/apps/TasksApp/components/FieldDropdown.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,aAAA;AAAF;;AAGA;EACE,UAAA;EACA,QAAA;AAAF;;AAGA;EACE,gCAAA;EACA,0CAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,YAAA;EACA,iDAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,0CAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mCAAA;AAAF;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,gCAAA;AADJ;;AAKA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AAFF;AAIE;EACE,UAAA;AAFJ;AAKE;EACE,uBAAA;AAHJ;AAME;EACE,iCAAA;EACA,kBAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;EACA,gBAAA;AANF;AAQE;EAEE,8BAAA;EACA,6BAAA;AAPJ;AAUE;EACE,6BAAA;AARJ;;AAYA;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AATF;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,yBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,+BAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,sBAAA;AAVF;;AAaA;EACE,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAVF;;AAaA;EACE,yBAAA;AAVF","sourcesContent":["// === FIELD DROPDOWN ===\n.tasksFieldDropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  z-index: 1000;\n}\n\n.tasksFieldDropdownAlignRight {\n  left: auto;\n  right: 0;\n}\n\n.tasksFieldDropdownPortal {\n  background: var(--ta-bg-primary);\n  border: 1px solid var(--ta-border-primary);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  min-width: 240px;\n  overflow: hidden;\n  animation: dropdownAppear 0.15s ease-out;\n}\n\n.tasksFieldDropdownSearch {\n  padding: 6px;\n  border-bottom: 1px solid var(--ta-border-primary);\n  font-size: 13px;\n}\n\n.tasksFieldDropdownSearchInput {\n  width: 100%;\n  padding: 6px 8px;\n  background: var(--ta-bg-secondary);\n  border: 1px solid var(--ta-border-primary);\n  border-radius: 4px;\n  color: var(--ta-text-primary);\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.15s ease;\n\n  &::placeholder {\n    color: var(--ta-text-tertiary);\n  }\n\n  &:focus {\n    border-color: var(--ta-blue-500);\n  }\n}\n\n.tasksFieldDropdownOptions {\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 4px;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--ta-border-dark);\n    border-radius: 4px;\n\n    &:hover {\n      background: #4a4a4a;\n    }\n  }\n}\n\n.tasksFieldDropdownOption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: var(--ta-text-primary);\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n  text-align: left;\n\n  &:hover,\n  &.tasksFieldDropdownOptionFocused {\n    background: var(--ta-bg-hover);\n    color: var(--ta-text-primary);\n  }\n\n  &.tasksFieldDropdownOptionSelected {\n    color: var(--ta-text-primary);\n  }\n}\n\n.tasksFieldDropdownOptionIcon {\n  font-size: 14px;\n  flex-shrink: 0;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ta-text-tertiary);\n\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.tasksFieldDropdownOptionLabel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tasksFieldDropdownOptionCheck {\n  color: var(--ta-blue-500);\n  flex-shrink: 0;\n}\n\n.tasksFieldDropdownOptionShortcut {\n  font-size: 11px;\n  color: var(--ta-text-secondary);\n  background: var(--ta-bg-tertiary);\n  padding: 2px 6px;\n  border-radius: 3px;\n  border: 1px solid var(--ta-border-primary);\n  flex-shrink: 0;\n  font-family: monospace;\n}\n\n.tasksFieldDropdownEmpty {\n  padding: 16px;\n  text-align: center;\n  color: var(--ta-text-dark-secondary);\n  font-size: 13px;\n}\n\n.tasksFieldDropdownOptionCreate {\n  color: var(--ta-blue-500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
